(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wm-lens-comparison-v2"] && !Shopify.designMode) return;
  try {
    
/* Progressive enhancement: cards, product links and specifications work without JS. */
(() => {
  if (!window.customElements || customElements.get('wm-lens-guide-v2')) return;

  class WMLensGuideV2 extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.initialized = false;
    }

    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.rail = this.querySelector('[data-rail]');
      this.cards = Array.from(this.querySelectorAll('[data-lens]'));
      if (!this.rail || !this.cards.length) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.current = this.cards.find(card => card.dataset.current === 'true');
      this.activeFilter = 'all';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.filterCopy = this.querySelector('[data-filter-copy]');
      this.filterStatus = this.querySelector('[data-filter-status]');
      this.position = this.querySelector('[data-position]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.comparePanel = this.querySelector('[data-comparison]');
      this.selects = Array.from(this.querySelectorAll('[data-select]'));
      this.onlyDifferences = this.querySelector('[data-only-differences]');
      this.isEditor = this.dataset.designMode === 'true';

      // Reorder only this section, never product variants or the merchant's saved block order.
      if (this.current && this.dataset.currentFirst === 'true' && !this.isEditor) {
        this.rail.prepend(this.current);
        this.cards = Array.from(this.rail.querySelectorAll('[data-lens]'));
      }

      this.querySelectorAll('[data-filter]').forEach(button => {
        const total = this.cards.filter(card => this.matches(card, button.dataset.filter)).length;
        const count = button.querySelector('[data-filter-count]');
        if (count) count.textContent = String(total);
        button.hidden = total === 0;
        button.addEventListener('click', () => this.filter(button.dataset.filter, true), {signal});
      });
      this.prev?.addEventListener('click', () => this.move(-1), {signal});
      this.next?.addEventListener('click', () => this.move(1), {signal});
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateNavigation());
      }, {passive: true, signal});
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      }, {signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-compare]');
        if (button && this.contains(button)) this.compareCard(button.dataset.compare);
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.key === event.detail?.blockId);
        if (!card) return;
        this.filter('all', false);
        requestAnimationFrame(() => this.scrollToCard(card, false));
      }, {signal});

      if (this.comparePanel && this.cards.length > 1) {
        this.prepareComparison(signal);
      } else {
        if (this.comparePanel) this.comparePanel.hidden = true;
        this.querySelectorAll('[data-compare]').forEach(button => { button.hidden = true; });
      }

      this.classList.add('is-ready');
      this.filter('all', false);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.rail);
      }
    }

    matches(card, filter) {
      if (filter === 'all') return true;
      if (filter === 'digital') return ['digital', 'advanced'].includes(card.dataset.category);
      return card.dataset.category === filter;
    }

    filter(name, announce) {
      this.activeFilter = name;
      this.cards.forEach(card => { card.hidden = !this.matches(card, name); });
      this.querySelectorAll('[data-filter]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.filter === name));
      });
      const descriptions = {
        all: 'Explore the lineup. Open any lens for the details.',
        passive: 'A fixed view, without electronics or automatic darkening.',
        single: 'Automatic darkening, with no buttons to adjust.',
        digital: 'Adjust shade, sensitivity, and delay on the lens.',
        advanced: 'Rechargeable digital models with USB-C power.'
      };
      if (this.filterCopy) this.filterCopy.textContent = descriptions[name] || descriptions.all;
      this.rail.scrollTo({left: 0, behavior: 'auto'});
      this.updateNavigation();
      if (announce && this.filterStatus) {
        const count = this.visibleCards().length;
        this.filterStatus.textContent = `${count} ${count === 1 ? 'lens' : 'lenses'} shown. ${descriptions[name] || ''}`;
      }
    }

    visibleCards() {
      return this.cards.filter(card => !card.hidden);
    }

    inViewCards() {
      const railRect = this.rail.getBoundingClientRect();
      return this.visibleCards().filter(card => {
        const rect = card.getBoundingClientRect();
        return Math.min(rect.right, railRect.right) - Math.max(rect.left, railRect.left) > rect.width * .5;
      });
    }

    updateNavigation() {
      const visible = this.visibleCards();
      if (!visible.length) return;
      const view = this.inViewCards();
      const firstIndex = Math.max(0, visible.indexOf(view[0]));
      const lastIndex = Math.max(firstIndex, visible.indexOf(view[view.length - 1]));
      const rect = this.rail.getBoundingClientRect();
      const first = visible[0].getBoundingClientRect();
      const last = visible[visible.length - 1].getBoundingClientRect();
      const rtl = getComputedStyle(this.rail).direction === 'rtl';
      if (this.prev) this.prev.disabled = rtl ? first.right <= rect.right + 5 : first.left >= rect.left - 5;
      if (this.next) this.next.disabled = rtl ? last.left >= rect.left - 5 : last.right <= rect.right + 5;
      if (this.position) this.position.textContent = firstIndex === lastIndex ? `${firstIndex + 1} / ${visible.length}` : `${firstIndex + 1}–${lastIndex + 1} / ${visible.length}`;
      const swipe = this.querySelector('.wm-lc__swipe-note');
      if (swipe) swipe.hidden = this.rail.scrollWidth <= this.rail.clientWidth + 4;
    }

    move(direction) {
      const visible = this.visibleCards();
      const current = this.inViewCards();
      const first = Math.max(0, visible.indexOf(current[0]));
      const step = Math.max(1, current.length);
      const index = Math.max(0, Math.min(visible.length - 1, first + direction * step));
      this.scrollToCard(visible[index], true);
    }

    scrollToCard(card, smooth) {
      if (!card) return;
      const railRect = this.rail.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const rtl = getComputedStyle(this.rail).direction === 'rtl';
      const delta = rtl ? cardRect.right - railRect.right + 3 : cardRect.left - railRect.left - 3;
      this.rail.scrollBy({left: delta, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'auto'});
    }

    prepareComparison(signal) {
      this.products = new Map(this.cards.map(card => {
        const fields = Array.from(card.querySelectorAll('[data-field]')).map(field => ({
          key: field.dataset.field,
          label: field.dataset.label,
          value: field.textContent.trim()
        }));
        return [card.dataset.key, {
          key: card.dataset.key,
          title: card.querySelector('.wm-lc__title').textContent.trim(),
          price: card.querySelector('.wm-lc__price')?.textContent.trim() || '',
          available: !card.querySelector('.wm-lc__sold-out'),
          url: card.querySelector('[data-product-link]').getAttribute('href'),
          image: card.querySelector('.wm-lc__image'),
          category: card.dataset.category,
          performanceGroup: card.dataset.performanceGroup || '',
          useNote: card.querySelector('[data-use-note-text]')?.textContent.trim() || '',
          useNoteHeading: card.querySelector('[data-use-note] strong')?.textContent.trim() || 'Before use',
          current: card.dataset.current === 'true',
          fields
        }];
      }));
      this.selects.forEach(select => {
        select.replaceChildren();
        this.products.forEach(product => {
          const option = document.createElement('option');
          option.value = product.key;
          option.textContent = product.title;
          select.append(option);
        });
        select.addEventListener('change', () => this.renderComparison(true), {signal});
      });
      this.onlyDifferences?.addEventListener('change', () => this.renderComparison(true), {signal});
      const first = this.current || this.cards[0];
      const firstIndex = this.cards.indexOf(first);
      // A similar family is a starting comparison, not an automated recommendation.
      const alternative = this.cards.find(card => card !== first && card.dataset.category === first.dataset.category)
        || this.cards[(firstIndex + 1) % this.cards.length];
      this.selects[0].value = first.dataset.key;
      this.selects[1].value = alternative.dataset.key;
      this.comparePanel.addEventListener('toggle', () => {
        if (this.comparePanel.open) this.renderComparison(false);
      }, {signal});
      this.renderComparison(false);
    }

    compareCard(key) {
      if (!this.comparePanel || this.cards.length < 2 || !this.products?.has(key)) return;
      const currentKey = this.current?.dataset.key;
      if (currentKey && key !== currentKey) {
        this.selects[0].value = currentKey;
        this.selects[1].value = key;
      } else if (this.selects[0].value !== key) {
        this.selects[1].value = key;
      }
      this.comparePanel.open = true;
      this.renderComparison(true);
      this.comparePanel.scrollIntoView({behavior: this.reducedMotion.matches ? 'auto' : 'smooth', block: 'start'});
      this.comparePanel.querySelector('summary')?.focus({preventScroll: true});
    }

    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }

    renderComparison(announce) {
      if (!this.products || this.selects.length !== 2) return;
      if (this.selects[0].value === this.selects[1].value) {
        this.selects[1].value = [...this.products.keys()].find(key => key !== this.selects[0].value);
      }
      const pair = this.selects.map(select => this.products.get(select.value));
      if (pair.some(product => !product)) return;
      this.selects.forEach((select, index) => {
        Array.from(select.options).forEach(option => { option.disabled = option.value === pair[1-index].key; });
      });
      pair.forEach((product, index) => {
        const container = this.querySelector(`[data-selected="${index}"]`);
        const copy = this.element('div', 'wm-lc__selected-copy');
        container.replaceChildren();
        if (product.image) {
          const image = product.image.cloneNode(false);
          image.removeAttribute('id');
          image.className = '';
          image.alt = '';
          image.width = 86;
          image.height = 76;
          image.sizes = '86px';
          container.append(image);
        }
        copy.append(this.element('p', 'wm-lc__selected-name', product.title));
        if (product.price) copy.append(this.element('p', 'wm-lc__selected-price', product.price));
        if (product.current) copy.append(this.element('span', 'wm-lc__selected-current', 'You’re viewing this lens'));
        if (!product.available) copy.append(this.element('span', 'wm-lc__selected-current', 'Currently sold out'));
        container.append(copy);
      });
      const familyNote = this.querySelector('[data-family-note]');
      const sameViewingFamily = pair[0].performanceGroup === 'digital-viewing-color' && pair[1].performanceGroup === 'digital-viewing-color';
      if (familyNote) familyNote.hidden = !sameViewingFamily || !familyNote.textContent.trim();
      const columnHeadings = this.querySelector('[data-column-headings]');
      columnHeadings.replaceChildren();
      pair.forEach((product, index) => {
        const column = this.element('p', 'wm-lc__column-name');
        column.append(this.element('small', '', `LENS ${index + 1}`), document.createTextNode(product.title));
        columnHeadings.append(column);
      });
      const notices = this.querySelector('[data-comparison-notices]');
      notices.replaceChildren();
      const sharedNotice = Boolean(pair[0].useNote) && pair[0].useNote === pair[1].useNote;
      (sharedNotice ? [pair[0]] : pair).forEach(product => {
        if (!product.useNote) return;
        const notice = this.element('p', 'wm-lc__use-note');
        const name = sharedNotice ? 'Both lenses' : product.title;
        notice.append(this.element('strong', '', `${name} — ${product.useNoteHeading}`), document.createTextNode(product.useNote));
        notices.append(notice);
      });
      const rows = this.querySelector('[data-comparison-rows]');
      const fragment = document.createDocumentFragment();
      let differences = 0;
      let comparedFields = 0;
      pair[0].fields.forEach(field => {
        const other = pair[1].fields.find(candidate => candidate.key === field.key);
        // Do not show a partial row as a false N/A or a missing-information badge.
        if (!field.value || !other?.value) return;
        comparedFields++;
        const values = [field.value, other.value];
        const normalized = values.map(value => value.replace(/\s+/g, ' ').trim().toLowerCase());
        const different = normalized[0] !== normalized[1];
        if (different) differences++;
        const row = this.element('div', `wm-lc__comparison-row${different ? ' wm-lc__row--different' : ''}`);
        row.setAttribute('role', 'listitem');
        row.hidden = Boolean(this.onlyDifferences?.checked && !different);
        const heading = this.element('h4', 'wm-lc__row-label', field.label);
        if (different) heading.append(this.element('span', 'wm-lc__different', 'Different'));
        const cells = this.element('div', 'wm-lc__row-values');
        values.forEach((value, index) => {
          const cell = this.element('p', 'wm-lc__row-value');
          cell.append(this.element('span', 'wm-lc__sr', `${pair[index].title}: `));
          cell.append(document.createTextNode(value));
          cells.append(cell);
        });
        row.append(heading, cells);
        fragment.append(row);
      });
      rows.replaceChildren(fragment);
      this.querySelector('[data-same-note]').hidden = differences !== 0 || comparedFields === 0;
      const links = this.querySelector('[data-comparison-links]');
      links.replaceChildren();
      pair.forEach(product => {
        const link = this.element('a', 'wm-lc__button', 'View lens');
        link.setAttribute('href', product.url);
        link.setAttribute('aria-label', `View ${product.title}`);
        links.append(link);
      });
      if (announce) {
        const mode = this.onlyDifferences?.checked ? ' Only differing specifications are shown.' : '';
        this.querySelector('[data-comparison-status]').textContent = `${pair[0].title} compared with ${pair[1].title}. ${differences} differing ${differences === 1 ? 'specification' : 'specifications'}.${mode}`;
      }
    }
  }
  customElements.define('wm-lens-guide-v2', WMLensGuideV2);
})();


  } catch(e) { console.error(e); }
})();
})();
